import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { initializeMetaPixel, trackMetaEvent } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initializeMetaPixel();
    trackMetaEvent('PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}